import React from "react"

import {FieldViewProps} from "../../../../../render/view"

type Props = {
    disabled?   : boolean
} & FieldViewProps

export default function FieldViewForUser_ControlViewEmpty(props: Props) {

    const height = _.get(props.params, 'height', 28)

    const classes = Classes("ui5-control-button is-empty", 's-{0}'.f(height), props.className, {
        "disabled": props.disabled
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>

                <div className="i5-user icon m-r-5"></div>
                <div className="ui5-txt-not-important-small lh-13em">
                    {props.field.placeholder}
                </div>

                <div className="btn-arrow flex-row-center-center w-16 m-l-5"></div>

            </div>
            {props.children}
        </>
    )
}
